import React from 'react';
import { Box, Center, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import wifiRouter24GhzImg from '../../../assets/images/wifi_router_2ghz.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../common/constants';
import { useParamBackUrl } from '../../../common/hooks/use-param-back-url';
import { useSetupBackUrl } from './use-setup-back-url';

/* istanbul ignore next -- @preserve */
export function Wifi24GhzInfo() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { withSetupBackUrl } = useSetupBackUrl();
  const backURL = useParamBackUrl(withSetupBackUrl('../device-scan?direction=back'));

  return (
    // Pull-to-refresh reloads the whole app, wiping the in-memory device setup state (qrCodeValues)
    // while the phone is still connected to the EVSE AP with no internet - stranding the user on the
    // generic InternetConnectionRecoveryPage. Disable it here since there's nothing to recover into.
    <SlidingAnimationPageBase
      title={t('Common.device setup')}
      backURL={backURL}
      includeTopNavHamButton
      px={4}
      disablePullToRefresh
    >
      <Box display="flex" flexDirection="column" h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Center pt={4} pb={2}>
          <Box position="relative" w="45vw" h="45vw">
            <Image
              data-testid="wifi-2ghz-info-image"
              src={wifiRouter24GhzImg}
              alt="2.4 GHz Wi-Fi router"
              w="100%"
              h="100%"
            />
          </Box>
        </Center>

        <VStack align="stretch" spacing={2} mb={2}>
          <Heading fontSize={24} fontWeight={600} textAlign="center">
            {t('Set Up Hardware.2ghz wifi required')}
          </Heading>
        </VStack>

        <VStack align="stretch" spacing={2}>
          <Text data-testid="wifi-2ghz-info-text" textAlign="center">
            {t('Set Up Hardware.2ghz wifi body prefix')}
            <Text as="span" fontWeight={700} color="#3DCD58">
              {t('Set Up Hardware.2ghz wifi accent')}
            </Text>
            {t('Set Up Hardware.2ghz wifi body suffix')}
          </Text>
        </VStack>

        <Center mt="auto" mb={5} flexDir={'column'}>
          <ArcButton
            data-testid="ev-charger-continue"
            onClick={() => navigate(withSetupBackUrl('../device-wifi-connection'))}
            w="100%"
            py={6}
            mt="auto"
            arcColor="#3DCD57"
          >
            {t('Common.continue')}
          </ArcButton>
        </Center>
      </Box>
    </SlidingAnimationPageBase>
  );
}
